import React from 'react';

import projectConfig, { PROJECT } from '~/projects/config';
import { ReactComponent as CatImgDesktop } from '~/projects/justdone/assets/crying_cat_desktop.svg';
import { ReactComponent as CatImgMobile } from '~/projects/justdone/assets/crying_cat_mobile.svg';
import SKCatImg from '~/projects/sidekicker/assets/crying_cat.webp';

type CancellationConfig = {
  getPrimaryImage: (isDesktop: boolean) => JSX.Element;
};

const cancellationConfigByProject: Readonly<
  Record<PROJECT, CancellationConfig>
> = {
  [PROJECT.JUSTDONE]: {
    getPrimaryImage: (isDesktop: boolean) => (
      <> {!isDesktop ? <CatImgMobile /> : <CatImgDesktop />}</>
    ),
  },
  [PROJECT.SIDEKICKER]: {
    getPrimaryImage: () => (
      <img src={SKCatImg} alt="" width={'100%'} height={'100%'} />
    ),
  },
};

const getConfigByProject = (): CancellationConfig => {
  return cancellationConfigByProject[projectConfig.project];
};

export const CANCELLATION_PROJECT_CONFIG = getConfigByProject();
